export enum PlanOverrideAction {
  OVERRIDE_CREATED = 'OVERRIDE_CREATED',
  OVERRIDE_UPDATED = 'OVERRIDE_UPDATED',
  OVERRIDE_STATUS_CHANGED = 'OVERRIDE_STATUS_CHANGED',
  OVERRIDE_DOCUMENT_ADDED = 'OVERRIDE_DOCUMENT_ADDED',
  OVERRIDE_DOCUMENT_REMOVED = 'OVERRIDE_DOCUMENT_REMOVED',
  OVERRIDE_DELETED = 'OVERRIDE_DELETED',
}
